import React from 'react';
import { api, apis } from 'api';
import OptionItem from './contact-option-item';
import TeamOptionItem from './team-option-item';
import { transMailContactModel2ContactItem } from '@web-common/utils/contact_util';
export const modelToContactInfo = (model, type) => {
    const email = contactApi.doGetModelDisplayEmail(model);
    const infoItem = model.contactInfo.find(info => info.contactItemType === 'EMAIL' && info.contactItemVal === email);
    return {
        contact: model,
        contactItem: infoItem,
        mailMemberType: type,
        inContactBook: true,
    };
};
export const getContactModelKey = (item) => `${item.id || '_'}_${item.email || '_'}`;
export const getTeamContactKey = (item) => `${item.id}_${item.orgRank}`;
export const buildOptionLabel = (item, search, useComposite) => {
    const key = useComposite ? `${item.id}###${item.email}` : (item === null || item === void 0 ? void 0 : item.email) || '';
    return {
        search,
        value: key,
        label: React.createElement(OptionItem, { key: key, item: item, search: search }),
    };
};
export const buildTeamOptionLabel = (item, search) => {
    const key = getTeamContactKey(item);
    return {
        search,
        value: item.id,
        label: React.createElement(TeamOptionItem, { key: key, item: item, search: search }),
    };
};
const contactApi = api.requireLogicalApi(apis.contactApiImpl);
export const equalModel = (source, target) => {
    if (!source || !target)
        return false;
    const sourceEmail = source.contact && contactApi.doGetModelDisplayEmail(source.contact);
    const targetEmail = target.contact && contactApi.doGetModelDisplayEmail(target.contact);
    return sourceEmail === targetEmail;
};
export const extractEmailsFromText = (str) => {
    var _a, _b, _c, _d;
    return (_d = (_c = (_b = (_a = str === null || str === void 0 ? void 0 : str.split(/[\s*\r\n,;；，、]+/)) === null || _a === void 0 ? void 0 : _a.filter(mail => mail.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))) === null || _b === void 0 ? void 0 : _b.filter((mail, index, arr) => arr.indexOf(mail) === index)) === null || _c === void 0 ? void 0 : _c.map(email => {
        var _a, _b;
        const emailWithName = (_b = (_a = email === null || email === void 0 ? void 0 : email.split(/[<>]+/)) === null || _a === void 0 ? void 0 : _a.filter(_ => _.length > 0)) === null || _b === void 0 ? void 0 : _b.reverse();
        const [mail, contactName] = emailWithName;
        return { mail, contactName };
    })) === null || _d === void 0 ? void 0 : _d.filter((mail, index, arr) => arr.findIndex(t => t.mail === mail.mail) === index);
};
export const getCopiedContact = (receiver) => {
    const inContactBook = receiver.type !== 'external';
    const contactEmail = receiver.email;
    const contactName = receiver.name || '';
    return inContactBook ? `${contactName}<${contactEmail}>` : contactEmail;
};
export const getCopiedContacts = (receivers, type, selectedEmails) => {
    const copiedContacts = [];
    receivers === null || receivers === void 0 ? void 0 : receivers.forEach(item => {
        if (item.mailMemberType === type) {
            const contactItem = transMailContactModel2ContactItem(item);
            if (selectedEmails.includes(contactItem.email)) {
                const copiedContact = getCopiedContact(contactItem);
                if (copiedContact) {
                    copiedContacts.push(copiedContact);
                }
            }
        }
    });
    return copiedContacts.join('\n');
};
export { isPointBefore, normalizePoints, isTagAfterOrAtPoint, isTagBeforeOrAtPoint, binarySearchFirstAfterPoint, binarySearchLastBeforePoint, getSelectedEmailsByPoints, } from './drag-select-utils';
